import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../RichText';

import { CtaContainer, CtaIcon, SocialMediaLink } from './styles';

const SocialMediaCta = ({ data }) => {
  if (!data) return null;

  const { iconDam, links, label, ariaLabel, analyticTracker } = data;

  const linkText = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <SocialMediaLink aria-label={ariaLabel}>{children}</SocialMediaLink>
      ),
    },
  };

  return (
    <CtaContainer href={links} id={analyticTracker} target="_blank">
      <CtaIcon src={iconDam} altText={iconDam.altText || ariaLabel} />
      {label && <RichText document={label} options={linkText} />}
    </CtaContainer>
  );
};

SocialMediaCta.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default SocialMediaCta;
